import React, {
    useCallback,
    useState,
} from 'react';
import { connectToField } from '@frontend/jetlend-core/src/ui/inputs/connect';
import iconEye from '@frontend/jetlend-assets/icons/icon-eye.svg';
import iconEyeActive from '@frontend/jetlend-assets/icons/icon-eye--active.svg';
import iconLock from '@frontend/jetlend-assets/icons/icon--lock.svg';
import { getAssetSrc } from '@frontend/jetlend-web-ui/src/utils/getAssetSrc';
import {
    InlineTextInputComponent,
    IProps as InlineTextInputProps,
} from '@ui/ui/inputs/InlineTextInput/InlineTextInput';
import IconButton from '@ui/ui/inputs/IconButton/IconButton';

export type IProps = InlineTextInputProps;

export const InlinePasswordInputComponent: React.FC<IProps> = props => {
    const [hidden, setHidden] = useState(true);

    const didVisibilityToggle = useCallback(() => {
        setHidden(hidden => !hidden);
    }, []);

    return (
        <div>
            <InlineTextInputComponent
                {...props}
                postfix={
                    <IconButton
                        icon={hidden ? iconEye : iconEyeActive}
                        hint={hidden ? 'Показать пароль' : 'Скрыть пароль'}
                        size="large"
                        onClick={didVisibilityToggle}
                    />
                }
                icon={getAssetSrc(iconLock)}
                inputType={hidden ? 'password' : 'text'}
            />
        </div>
    );
};

export default connectToField(InlinePasswordInputComponent);